import { Badge, Tabs as RawTabs, TabsTabProps } from '@mantine/core';
import { ColorVariantType } from 'common/constants/colors.styles';
import React from 'react';
import { PredefinedFirst } from 'types/helper.type';

import Text, { TextProps } from './text';

export type TabData = {
  label: string;
  badge?: number;
  badgeColor?: PredefinedFirst<ColorVariantType>;
} & TabsTabProps;

export interface TabsProps extends React.ComponentProps<typeof RawTabs> {
  textProps?: TextProps;
  data: TabData[];
}

export default function Tabs(props: TabsProps) {
  const { data, textProps, ...rest } = props;
  return (
    <RawTabs {...rest}>
      <RawTabs.List>
        {data.map(({ label, badge, badgeColor, ...item }) => {
          return (
            <RawTabs.Tab
              key={item.value}
              {...item}
              rightSection={
                (badge || 0) > 0 && (
                  <Badge color={badgeColor} children={badge} />
                )
              }
            >
              <Text {...textProps}>{label}</Text>
            </RawTabs.Tab>
          );
        })}
      </RawTabs.List>
    </RawTabs>
  );
}
